import { TabAction } from '@src/types/tabAction';

export const Logout = ({ actions }: { actions: TabAction[] }) => {
  return (
    <div className="tab-buttons__right">
      {actions.map((action, i) => (
        <div key={i} className="tab-buttons__right__item" onClick={action.onClick}>
          <span>{action.label}</span>
          {action.icon}
        </div>
      ))}
    </div>
  );
};
